import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-5c534252"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "p-mb-0 p-mt-6 p-text-center" }
const _hoisted_2 = { class: "p-error p-mb-3 p-text-center" }
const _hoisted_3 = { class: "p-inputgroup" }
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-eye" })
], -1))
const _hoisted_5 = { class: "p-pl-2 p-ml-2 p-mt-0" }
const _hoisted_6 = { class: "p-inputgroup p-mt-2" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-eye" })
], -1))
const _hoisted_8 = { class: "p-inputgroup p-mt-2" }
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "p-inputgroup-addon" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "pi pi-box" })
], -1))
const _hoisted_10 = { class: "p-d-flex p-jc-around p-col-12" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ProgressBar = _resolveComponent("ProgressBar")!
  const _component_Divider = _resolveComponent("Divider")!
  const _component_Password = _resolveComponent("Password")!
  const _component_FieldErrors = _resolveComponent("FieldErrors")!
  const _component_InputText = _resolveComponent("InputText")!
  const _component_InputNumber = _resolveComponent("InputNumber")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.$t("resetPassword.formTitle")), 1),
    _createElementVNode("small", _hoisted_2, _toDisplayString(_ctx.$t("resetPassword.tentative")) + " : " + _toDisplayString(_ctx.session?.resentTimes) + " / 3 ", 1),
    _createElementVNode("form", {
      onSubmit: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.submit()), ["prevent"])),
      class: "p-grid p-p-3"
    }, [
      _createVNode(_component_ProgressBar, {
        mode: "indeterminate",
        style: {"height":"0.5em"}
      }),
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _createVNode(_component_Password, {
          modelValue: _ctx.form.password.$value,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.password.$value) = $event)),
          class: _normalizeClass({ 'p-invalid': _ctx.form.password.$hasError }),
          onBlur: _cache[1] || (_cache[1] = ($event: any) => (_ctx.form.password.$validate())),
          placeholder: _ctx.$t('signUp.password')
        }, {
          footer: _withCtx(() => [
            _createVNode(_component_Divider, { style: {"background":"gainsboro","height":"1px"} }),
            _createElementVNode("ul", _hoisted_5, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.$tm('validation.validPassword'), (m, index) => {
                return (_openBlock(), _createElementBlock("li", { key: index }, _toDisplayString(m), 1))
              }), 128))
            ])
          ]),
          _: 1
        }, 8, ["modelValue", "class", "placeholder"])
      ]),
      _createVNode(_component_FieldErrors, {
        errors: _ctx.form.password.$errors
      }, null, 8, ["errors"]),
      _createElementVNode("div", _hoisted_6, [
        _hoisted_7,
        _createVNode(_component_InputText, {
          type: "password",
          placeholder: _ctx.$t('resetPassword.confirm'),
          modelValue: _ctx.form.confirm.$value,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.confirm.$value) = $event)),
          class: _normalizeClass({ 'p-invalid': _ctx.form.confirm.$hasError }),
          onBlur: _cache[3] || (_cache[3] = ($event: any) => (_ctx.form.confirm.$validate()))
        }, null, 8, ["placeholder", "modelValue", "class"])
      ]),
      _createVNode(_component_FieldErrors, {
        errors: _ctx.form.confirm.$errors
      }, null, 8, ["errors"]),
      _createElementVNode("div", _hoisted_8, [
        _hoisted_9,
        _createVNode(_component_InputNumber, {
          modelValue: _ctx.form.code.$value,
          "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.code.$value) = $event)),
          placeholder: _ctx.$t('resetPassword.enterCode'),
          class: _normalizeClass({ 'p-invalid': _ctx.form.code.$hasError }),
          onBlur: _cache[5] || (_cache[5] = ($event: any) => (_ctx.form.code.$validate()))
        }, null, 8, ["modelValue", "placeholder", "class"])
      ]),
      _createVNode(_component_FieldErrors, {
        errors: _ctx.form.code.$errors
      }, null, 8, ["errors"]),
      _createElementVNode("div", _hoisted_10, [
        (_ctx.session?.resentTimes < 3)
          ? (_openBlock(), _createBlock(_component_Button, {
              key: 0,
              label: _ctx.$t('resetPassword.resent'),
              class: "p-button-warning p-button-rounded",
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.resentCode()))
            }, null, 8, ["label"]))
          : _createCommentVNode("", true),
        _createVNode(_component_Button, {
          "icon-pos": "right",
          icon: "pi pi-send",
          label: _ctx.$t('resetPassword.submit'),
          disabled: _ctx.hasError,
          type: "submit",
          class: "p-button-rounded"
        }, null, 8, ["label", "disabled"])
      ])
    ], 32)
  ], 64))
}